/**
 * Google Maps Formatter.
 * @param {*} value
 * @param {*} row
 * @returns {*}
 */
window.googleMapsFormatter = function(value, row) {
    let html = '';
    if (row.latitude && row.longitude) {
        html += '<i class="google-maps-formatter fa fa-globe" ';
        if (typeof row.title !== "undefined") {
            html += 'data-title="' + row.title + '" ';
        }
        if (typeof row.latitude !== "undefined") {
            html += 'data-latitude="' + row.latitude + '" ';
        }
        if (typeof row.longitude !== "undefined") {
            html += 'data-longitude="' + row.longitude + '" ';
        }
        if (typeof row.radius !== "undefined") {
            html += 'data-radius="' + row.radius + '" ';
        }
        if (typeof row.marker !== "undefined") {
            html += 'data-marker="' + row.marker + '" ';
        }
        if (typeof row.information !== "undefined") {
            html += 'data-information="' + row.information + '" ';
        }
        if (typeof row.zoom !== "undefined") {
            html += 'data-zoom="' + row.zoom + '" ';
        }
        if (typeof row.type !== "undefined") {
            html += 'data-type="' + row.type + '" ';
        }
        html += 'style="cursor: pointer">';
        html += '</i>';
    }
    return html;
};
